import { apiClient } from '~/api/client';
import { UserDataJSONAPI } from '~/sections/user-profile/types';

type Params = {
  queryKey: Array<string>;
};

type Response = {
  data: UserDataJSONAPI[];
};

export const index = async (params: Params) => {
  const sort = params.queryKey[1] === 'Alphabetical [A-Z]' ? 'asc' : 'desc';
  return apiClient.get<Response>(`/current_user/company/users/?sort=${sort}`);
};
